import { render } from "./RobosFilas.vue?vue&type=template&id=08d8eeac&scoped=true"
import script from "./RobosFilas.vue?vue&type=script&lang=ts"
export * from "./RobosFilas.vue?vue&type=script&lang=ts"

import "./RobosFilas.vue?vue&type=style&index=0&id=08d8eeac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-08d8eeac"

export default script